import { Autocomplete, Box, Dialog, IconButton, Skeleton, Table, TableBody, TableCell, TableHead, TableRow, TextField, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { AXIS_OPTIONS, COMMON_STYLE, CYL_OPTIONS, SPH_OPTIONS } from '../../../../Utility/Constants';
import ShowComponents from '../../DoctorNotes/Common/ShowComponent';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import CloseIcon from '@mui/icons-material/Close';


const UmaRetinoRefraction = React.forwardRef((props, ref) => {
    const [retino, setRetino] = useState({
    patient_details: {},
    clinic_id: '',
    appointment_id: '',
    patient_id: '',
    beforeDilation: [],
    afterDilation: [],
    SPHList: SPH_OPTIONS,
    CYLList: CYL_OPTIONS,
    AXISList: AXIS_OPTIONS,
    retinoComments: '',
    loadScreen: false,
    prevBeforeDilation: [],
    prevAfterDilation: [],
    prevRetinoComments: '',
    enableAftCopy: false,
    enableBfrCompare: false,
    enableBfrCopy: false,
    enableAftCompare: false,
    openAftComparePopup: false,
    openBfrComparePopup: false,
    dupAfterDilation: '[]',
    dupBeforeDilation: '[]',
    dupRetinoComments: ''
})
    const [message, setMessage] = useState({
        isErrorMsgText: '',
        successMsgText: '',
        isErrorMsg: false,
        successMsg: false,
    })

    const errorMessage = (message) => {
        setMessage({
            ...message,
            isErrorMsg: true,
            isErrorMsgText: `${message} - RETINOSCOPIC REFRACTION`,
        })
    }

    const successMessage = (message) => {
        setMessage({
            ...message,
            successMsg: true,
            successMsgText: `${message} - RETINOSCOPIC REFRACTION`,
        })
    }

    const msgClose = () => {
        setMessage({
            ...message,
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    React.useImperativeHandle(ref, () => ({
        performRetinoRefractionAction: () => {
            if (
                (JSON.stringify(retino.beforeDilation) !== retino.dupBeforeDilation) ||
                (JSON.stringify(retino.afterDilation) !== retino.dupAfterDilation) ||
                (JSON.stringify(retino.retinoComments) !== retino.dupRetinoComments)
            ) {
                postRetinoRefraData()
            }
        }
    }))

    const apicalls = async () => {
        await getRetinoRefraData()
        await getPrevRetinoRefraData()
    }

    useEffect(() => {
        if (retino.beforeDilation && retino.afterDilation && retino.prevAfterDilation && retino.prevBeforeDilation) {
            let aftrCopy = retino.prevAfterDilation?.length > 0 ? retino.prevAfterDilation?.some((item) => (item?.SPH !== '' || item?.CYL !== '' || item?.AXIS)) : false
            let bfrCopy = retino.prevBeforeDilation?.length > 0 ? retino.prevBeforeDilation?.some((item) => (item?.SPH !== '' || item?.CYL !== '' || item?.AXIS)) : false
            let bfrCompare = retino.beforeDilation?.length > 0 ? retino.beforeDilation?.some((item) => (item?.SPH !== '' || item?.CYL !== '' || item?.AXIS)) : false
            let aftrCompare = retino.afterDilation?.length > 0 ? retino.afterDilation?.some((item) => (item?.SPH !== '' || item?.CYL !== '' || item?.AXIS)) : false
            setRetino((prev) => ({
                ...prev,
                enableAftCompare: aftrCompare,
                enableAftCopy: aftrCopy,
                enableBfrCopy: bfrCopy,
                enableBfrCompare: bfrCompare
            }))
        }
    }, [retino.beforeDilation, retino.afterDilation, retino.prevAfterDilation, retino.prevBeforeDilation])

    const getRetinoRefraData = async () => {
        try {
            const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_RETINO_REFRACTION + '?appointment_id=' + props.props.appointment_id + '&doctor_id=' + props?.props?.doctorID)

            if (response?.data?.status === 'success') {
                let retinoList = Object.keys(response?.data?.data)?.length > 0 ? response?.data?.data : {}
                let bfreDil = [
                    { "eye_type": "RE", "SPH": "", "CYL": "", "AXIS": "", "UCVA": "", "BCDVA": "", "BCNVA": "", "add": "" },
                    { "eye_type": "LE", "SPH": "", "CYL": "", "AXIS": "", "UCVA": "", "BCDVA": "", "BCNVA": "", "add": "" },
                ]
                let aftrDil = [
                    { "eye_type": "RE", "SPH": "", "CYL": "", "AXIS": "", "UCVA": "", "BCDVA": "", "BCNVA": "", "add": "" },
                    { "eye_type": "LE", "SPH": "", "CYL": "", "AXIS": "", "UCVA": "", "BCDVA": "", "BCNVA": "", "add": "" },
                ]
                setRetino((prev) => ({
                    ...prev,
                    beforeDilation: Object.keys(retinoList)?.length > 0 ? retinoList?.before_dilation : bfreDil,
                    afterDilation: Object.keys(retinoList)?.length > 0 ? retinoList?.after_dilation : aftrDil,
                    retinoComments: Object.keys(retinoList)?.length > 0 ? retinoList?.comment : '',

                    dupBeforeDilation: Object.keys(retinoList)?.length > 0 ? JSON.stringify(retinoList?.before_dilation) : JSON.stringify(bfreDil),
                    dupAfterDilation: Object.keys(retinoList)?.length > 0 ? JSON.stringify(retinoList?.after_dilation) : JSON.stringify(aftrDil),
                    dupRetinoComments: Object.keys(retinoList)?.length > 0 ? JSON.stringify(retinoList?.comment) : JSON.stringify(''),
                }))
            }
        } catch (error) {
            if (error?.response?.data?.message) {
                errorMessage(error?.response?.data?.message)
            } else {
                errorMessage(error?.message)
            }
        }
    }

    const getPrevRetinoRefraData = async () => {
        try {
            const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_RETINO_REFRACTION_COPY +
                '?appointment_id=' + props.props.appointment_id + '&patient_id=' + props.props.patient_id + '&doctor_id=' + props?.props?.doctorID
            )
            if (response?.data?.status === 'success') {
                let retinoList = Object.keys(response?.data?.data)?.length > 0 ? response?.data?.data : {}
                setRetino((prev) => ({
                    ...prev,
                    prevBeforeDilation: Object.keys(retinoList)?.length > 0 ? retinoList?.before_dilation : [],
                    prevAfterDilation: Object.keys(retinoList)?.length > 0 ? retinoList?.after_dilation : [],
                    prevRetinoComments: Object.keys(retinoList)?.length > 0 ? retinoList?.comment : '',
                }))
            }
        } catch (error) {
            if (error?.response?.data?.message) {
                errorMessage(error?.response?.data?.message)
            } else {
                errorMessage(error?.message)
            }
        }
    }

    const postRetinoRefraData = async () => {
        try {
            let data = {
                appointment_id: props.props.appointment_id,
                comment: retino.retinoComments,
                before_dilation: retino.beforeDilation,
                after_dilation: retino.afterDilation
            }
            const response = await RestAPIService.create(data, Serviceurls.NEW_DOC_NOTES_RETINO_REFRACTION)

            if (response?.data.status === 'success') {
                successMessage(response?.data?.message)
                await getRetinoRefraData()
            }

        } catch (error) {
            if (error?.response?.data?.message) {
                errorMessage(error?.response?.data?.message)
            } else {
                errorMessage(error?.message)
            }
        }
    }

    const autocompleteTextBox = (names, values, options = [], optionLabel, placeholders, index, key) => {
        try {
            return (
                <Autocomplete
                    disabled={props?.props?.patient_transfered || props?.props?.isLocked}
                    clearIcon
                    size='small'
                    sx={{ width: '10dvw' }}
                    value={values || ""}
                    options={options}
                    getOptionLabel={(option) => typeof (option) === 'string' ? option : option[optionLabel] || ""}
                    onChange={(e, newValue) => {
                        if (key === 'Before') {
                            let beforeDilation = [...retino.beforeDilation]
                            beforeDilation[index] = { ...beforeDilation[index], [names]: newValue ? newValue?.label || "" : "" }
                            setRetino((prev) => ({ ...prev, beforeDilation: beforeDilation }))
                        } else {
                            let afterDilation = [...retino.afterDilation]
                            afterDilation[index] = { ...afterDilation[index], [names]: newValue ? newValue?.label || "" : "" }
                            setRetino((prev) => ({ ...prev, afterDilation: afterDilation }))
                        }
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            placeholder={placeholders}
                            InputProps={{
                                ...params.InputProps, emed_tid: names,
                                style: { height: COMMON_STYLE.HEIGHT, padding: COMMON_STYLE.PADDING }
                            }}
                        />
                    )}
                />
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const beforeDilationTable = () => {
        try {
            return (
                <Box component={'div'} mt={'0.5rem'}>
                    <Box component={'div'} display={'flex'} alignItems={'center'}>
                        <Typography className='doc_notes_header_card_font'>Before Dilation</Typography>
                        <Box component={'div'} display={'flex'} alignItems={'center'} ml={'0.5rem'}>
                            <Tooltip placement='top' arrow title={'Copy'}><IconButton className='Common_Btn_Min_Width' emed_tid='rtno_cpy'
                                disabled={!retino.enableBfrCopy || props?.props?.patient_transfered || props?.props?.isLocked}
                                onClick={() => setRetino((prev) => ({
                                    ...prev, openBfrComparePopup: false,
                                    beforeDilation: retino.prevBeforeDilation
                                }))}
                            ><ContentCopyIcon color={!retino?.enableBfrCopy ? '' : 'primary'} /></IconButton></Tooltip>
                            <Tooltip placement='top' arrow title={'View'}><IconButton className='Common_Btn_Min_Width' emed_tid='rtno_vis'
                                onClick={() => setRetino((prev) => ({ ...prev, openBfrComparePopup: true }))}
                                disabled={!(retino.enableBfrCopy && retino.enableBfrCompare) || props?.props?.patient_transfered || props?.props?.isLocked}
                            ><VisibilityIcon color={!(retino.enableBfrCopy && retino.enableBfrCompare) ? '' : 'primary'} /></IconButton></Tooltip>
                        </Box>
                    </Box>
                    <Box component={'div'} border={'1px solid lightgray'} m={'0.5rem 0rem'}>
                        <Table size='small'>
                            <TableHead>
                                <TableRow>
                                    <TableCell className='doc_notes_tbl_header'>Eye</TableCell>
                                    <TableCell className='doc_notes_tbl_header'>SPH</TableCell>
                                    <TableCell className='doc_notes_tbl_header'>CYL</TableCell>
                                    <TableCell className='doc_notes_tbl_header'>AXIS</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {retino?.beforeDilation?.length > 0 ? retino?.beforeDilation?.map((item, index) => {
                                    return (
                                        <TableRow key={index}>
                                            <TableCell className='doc_notes_tbl_body_cell doc_notes_header_card_font'>{item?.eye_type}</TableCell>
                                            <TableCell className='doc_notes_tbl_body_cell'>
                                                {autocompleteTextBox('SPH', item?.SPH, retino?.SPHList, 'label', 'SPH', index, 'Before')}
                                            </TableCell>
                                            <TableCell className='doc_notes_tbl_body_cell'>
                                                {autocompleteTextBox('CYL', item?.CYL, retino?.CYLList, 'label', 'CYL', index, 'Before')}
                                            </TableCell>
                                            <TableCell className='doc_notes_tbl_body_cell'>
                                                {autocompleteTextBox('AXIS', item?.AXIS, retino?.AXISList, 'label', 'AXIS', index, 'Before')}
                                            </TableCell>
                                        </TableRow>
                                    )
                                }) : <TableRow><TableCell align='center' colSpan={4}>{COMMON_STYLE.NO_RECORDS}</TableCell></TableRow>}
                            </TableBody>
                        </Table>
                    </Box>
                </Box>
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const renderBfrComparePopup = () => {
        try {
            return (
                <Dialog open={retino.openBfrComparePopup} maxWidth="md" fullWidth>
                    <Box className='doc_addendum_popup'>
                        <Box component={'div'} p={'0.2rem 0.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} borderBottom={'2px solid lightgray'}>
                            <Typography className='doc_notes_header_card_font'>Compare Before Dilation Retinoscopic Refraction</Typography>
                            <IconButton emed_tid='cmp_prev_cls'
                                onClick={() => setRetino((prev) => ({ ...prev, openBfrComparePopup: false }))}><CloseIcon /></IconButton>
                        </Box>
                        <Box component={'div'} p={'0.5rem'}>
                            <Box component={'div'} display={'flex'} alignItems={'center'}>
                                <Typography className='doc_notes_header_card_font'>Current Before Dilation</Typography>
                                <Tooltip placement='top' arrow title={'Copy'}>
                                    <IconButton className='Common_Btn_Min_Width' sx={{ height: '3dvh' }} emed_tid='prev_cmp_cpy'
                                        onClick={() => {
                                            setRetino((prev) => ({
                                                ...prev,
                                                beforeDilation: retino.prevBeforeDilation,
                                                openBfrComparePopup: false
                                            }))
                                        }}
                                    ><ContentCopyIcon color={'primary'} /></IconButton></Tooltip>
                            </Box>
                            <Box component={'div'} border={'1px solid lightgray'} mt={'0.5rem'}>
                                <Table size='small'>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className='doc_notes_tbl_header'>Eye</TableCell>
                                            <TableCell className='doc_notes_tbl_header'>SPH</TableCell>
                                            <TableCell className='doc_notes_tbl_header'>CYL</TableCell>
                                            <TableCell className='doc_notes_tbl_header'>AXIS</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {retino.prevBeforeDilation?.map((item, index) => {
                                            return (
                                                <TableRow key={index}>
                                                    <TableCell className='doc_notes_tbl_body_cell'>{item.eye_type}</TableCell>
                                                    <TableCell className='doc_notes_tbl_body_cell'>{item.SPH}</TableCell>
                                                    <TableCell className='doc_notes_tbl_body_cell'>{item.CYL}</TableCell>
                                                    <TableCell className='doc_notes_tbl_body_cell'>{item.AXIS}</TableCell>
                                                </TableRow>
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            </Box>
                        </Box>
                        <Box component={'div'} p={'0.5rem'}>
                            <Typography className='doc_notes_header_card_font'>New Before Dilation</Typography>
                            <Box component={'div'} border={'1px solid lightgray'} mt={'0.5rem'}>
                                <Table size='small'>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className='doc_notes_tbl_header'>Eye</TableCell>
                                            <TableCell className='doc_notes_tbl_header'>SPH</TableCell>
                                            <TableCell className='doc_notes_tbl_header'>CYL</TableCell>
                                            <TableCell className='doc_notes_tbl_header'>AXIS</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {retino.beforeDilation?.map((item, index) => {
                                            return (
                                                <TableRow key={index}>
                                                    <TableCell className='doc_notes_tbl_body_cell'>{item.eye_type}</TableCell>
                                                    <TableCell className='doc_notes_tbl_body_cell'>{item.SPH}</TableCell>
                                                    <TableCell className='doc_notes_tbl_body_cell'>{item.CYL}</TableCell>
                                                    <TableCell className='doc_notes_tbl_body_cell'>{item.AXIS}</TableCell>
                                                </TableRow>
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            </Box>
                        </Box>
                    </Box>
                </Dialog >
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const afterDilationScreen = () => {
        try {
            return (
                <Box component={'div'} mt={'0.5rem'}>
                    <Box component={'div'} display={'flex'} alignItems={'center'}>
                        <Typography className='doc_notes_header_card_font'>After Dilation</Typography>
                        <Box component={'div'} display={'flex'} alignItems={'center'} mr={'0.5rem'}>
                            <Tooltip placement='top' arrow title={'Copy'}><IconButton className='Common_Btn_Min_Width' emed_tid='rtno_cpy'
                                onClick={() => setRetino((prev) => ({
                                    ...prev,
                                    openAftComparePopup: false,
                                    afterDilation: retino.prevAfterDilation
                                }))}
                                disabled={!retino.enableAftCopy || props?.props?.patient_transfered || props?.props?.isLocked}
                            ><ContentCopyIcon color={!retino.enableAftCopy ? '' : 'primary'} /></IconButton></Tooltip>
                            <Tooltip placement='top' arrow title={'View'}><IconButton className='Common_Btn_Min_Width' emed_tid='rtno_vis'
                                onClick={() => setRetino((prev) => ({ ...prev, openAftComparePopup: true }))}
                                disabled={!(retino.enableAftCopy && retino.enableAftCompare) || props?.props?.patient_transfered || props?.props?.isLocked}
                            ><VisibilityIcon color={!(retino.enableAftCopy && retino.enableAftCompare) ? '' : 'primary'} /></IconButton></Tooltip>
                        </Box>
                    </Box>
                    <Box component={'div'} border={'1px solid lightgray'} m={'0.5rem 0rem'}>
                        <Table size='small'>
                            <TableHead>
                                <TableRow>
                                    <TableCell className='doc_notes_tbl_header'>Eye</TableCell>
                                    <TableCell className='doc_notes_tbl_header'>SPH</TableCell>
                                    <TableCell className='doc_notes_tbl_header'>CYL</TableCell>
                                    <TableCell className='doc_notes_tbl_header'>AXIS</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {retino?.afterDilation?.length > 0 ? retino?.afterDilation?.map((item, index) => {
                                    return (
                                        <TableRow key={index}>
                                            <TableCell className='doc_notes_tbl_body_cell doc_notes_header_card_font'>{item?.eye_type}</TableCell>
                                            <TableCell className='doc_notes_tbl_body_cell'>
                                                {autocompleteTextBox('SPH', item?.SPH, retino?.SPHList, 'label', 'SPH', index)}
                                            </TableCell>
                                            <TableCell className='doc_notes_tbl_body_cell'>
                                                {autocompleteTextBox('CYL', item?.CYL, retino?.CYLList, 'label', 'CYL', index)}
                                            </TableCell>
                                            <TableCell className='doc_notes_tbl_body_cell'>
                                                {autocompleteTextBox('AXIS', item?.AXIS, retino?.AXISList, 'label', 'AXIS', index)}
                                            </TableCell>
                                        </TableRow>
                                    )
                                }) : <TableRow><TableCell align='center' colSpan={4}>{COMMON_STYLE.NO_RECORDS}</TableCell></TableRow>}
                            </TableBody>
                        </Table>
                    </Box>
                </Box>
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const renderAftComparePopup = () => {
        try {
            return (
                <Dialog open={retino.openAftComparePopup} maxWidth="md" fullWidth>
                    <Box className='doc_addendum_popup'>
                        <Box component={'div'} p={'0.2rem 0.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} borderBottom={'2px solid lightgray'}>
                            <Typography className='doc_notes_header_card_font'>Compare After Dilation Retinoscopic Refraction</Typography>
                            <IconButton emed_tid='cmp_prev_cls'
                                onClick={() => setRetino((prev) => ({ ...prev, openAftComparePopup: false }))}><CloseIcon /></IconButton>
                        </Box>
                        <Box component={'div'} p={'0.5rem'}>
                            <Box component={'div'} display={'flex'} alignItems={'center'}>
                                <Typography className='doc_notes_header_card_font'>Current After Dilation</Typography>
                                <Tooltip placement='top' arrow title={'Copy'}>
                                    <IconButton className='Common_Btn_Min_Width' sx={{ height: '3dvh' }} emed_tid='prev_cmp_cpy'
                                        onClick={() => {
                                            setRetino((prev) => ({
                                                ...prev,
                                                afterDilation: retino.prevAfterDilation,
                                                openAftComparePopup: false
                                            }))
                                        }}
                                    ><ContentCopyIcon color={'primary'} /></IconButton></Tooltip>
                            </Box>
                            <Box component={'div'} border={'1px solid lightgray'} mt={'0.5rem'}>
                                <Table size='small'>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className='doc_notes_tbl_header'>Eye</TableCell>
                                            <TableCell className='doc_notes_tbl_header'>SPH</TableCell>
                                            <TableCell className='doc_notes_tbl_header'>CYL</TableCell>
                                            <TableCell className='doc_notes_tbl_header'>AXIS</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {retino.prevAfterDilation?.map((item, index) => {
                                            return (
                                                <TableRow key={index}>
                                                    <TableCell className='doc_notes_tbl_body_cell'>{item.eye_type}</TableCell>
                                                    <TableCell className='doc_notes_tbl_body_cell'>{item.SPH}</TableCell>
                                                    <TableCell className='doc_notes_tbl_body_cell'>{item.CYL}</TableCell>
                                                    <TableCell className='doc_notes_tbl_body_cell'>{item.AXIS}</TableCell>
                                                </TableRow>
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            </Box>
                        </Box>
                        <Box component={'div'} p={'0.5rem'}>
                            <Typography className='doc_notes_header_card_font'>New After Dilation</Typography>
                            <Box component={'div'} border={'1px solid lightgray'} mt={'0.5rem'}>
                                <Table size='small'>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className='doc_notes_tbl_header'>Eye</TableCell>
                                            <TableCell className='doc_notes_tbl_header'>SPH</TableCell>
                                            <TableCell className='doc_notes_tbl_header'>CYL</TableCell>
                                            <TableCell className='doc_notes_tbl_header'>AXIS</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {retino.afterDilation?.map((item, index) => {
                                            return (
                                                <TableRow key={index}>
                                                    <TableCell className='doc_notes_tbl_body_cell'>{item.eye_type}</TableCell>
                                                    <TableCell className='doc_notes_tbl_body_cell'>{item.SPH}</TableCell>
                                                    <TableCell className='doc_notes_tbl_body_cell'>{item.CYL}</TableCell>
                                                    <TableCell className='doc_notes_tbl_body_cell'>{item.AXIS}</TableCell>
                                                </TableRow>
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            </Box>
                        </Box>
                    </Box>
                </Dialog >
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    return (
        <ShowComponents onIntersection={apicalls}>
            <Box component={'div'}>
                <Box component={'div'}>
                    <Box component={'div'} className='doc_notes_header_card' display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                        <Typography className='doc_notes_header_card_font'>Retinoscopic Refraction</Typography>
                    </Box>
                    <Box component={'div'} m={'0.5rem'}>
                        {beforeDilationTable()}
                        {afterDilationScreen()}
                        <Box component={'div'}>
                            <TextField
                                disabled={props?.props?.patient_transfered || props?.props?.isLocked}
                                size='small'
                                multiline
                                fullWidth
                                maxRows={5}
                                value={retino.retinoComments}
                                onChange={(e) => {
                                    let value = e.target.value
                                    if (value?.length <= COMMON_STYLE.CHAR_LIMIT_DESP || value === '') {
                                        setRetino((prev) => ({ ...prev, retinoComments: value }))
                                    }
                                }}
                                placeholder='Comments'
                                inputProps={{ emed_tid: 'rtno_cmts', maxLength: COMMON_STYLE.CHAR_LIMIT_DESP }}
                            />
                        </Box>
                    </Box>
                </Box>
                {renderAftComparePopup()}
                {renderBfrComparePopup()}
                {message.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={message.isErrorMsgText}
                        msgPop={msgClose}
                    />
                    : null}
                {message.successMsg ?
                    <ToastMsg
                        severity={'success'}
                        msg={message.successMsgText}
                        msgPop={msgClose}
                    />
                    : null}
            </Box>
        </ShowComponents>
    )
})

export default UmaRetinoRefraction